import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-base-modal-example',
  templateUrl: './base-modal-example.component.html',
})
export class BaseModalExampleComponent {
  @Input() name = 'Usuario';

  getData() {
    return { confirmed: true };
  }
}
